/**
 * Accès réactif à la session courante — pour les écrans qui adaptent leurs actions
 * au rôle (RBAC UI). S'abonne aux changements : une reconnexion ou une déconnexion
 * met à jour les composants sans rechargement.
 */
import { useEffect, useState } from 'react'

import { getSession, subscribe, type Session } from '../auth/session'

export function useSession(): Session | null {
  const [session, setSession] = useState<Session | null>(getSession())
  useEffect(() => subscribe(setSession), [])
  return session
}
